import React, { useEffect, useState } from "react";
import { QrReader, QrReaderProps } from "react-qr-reader";
import AssetDetails from "./AssetDetails";
import "./style.scss";
import { CloseIcon } from "../../assets/images";
import jsQR from "jsqr";
import { TableLoader } from "../commons";

type AppProps = {
  onClose: () => void;
  message: string | null;
  getSingleData: (data: any) => void;
  singleFixedAsset: any;
  handleReset: () => void;
  handleSubmit: (condition: string, id: string) => void;
};

const QrCodeScanner = ({
  onClose,
  message,
  getSingleData,
  handleSubmit,
  singleFixedAsset,
  handleReset,
}: AppProps) => {
  const [delay] = useState<number>(100);
  const [result, setResult] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [facingMode, setFacingMode] = useState<"user" | "environment">(
    "environment"
  );

  // trying
  const [imageData, setImageData] = useState<any>(null);
  const [fileName, setFileName] = useState<any>(null);

  const handleScan = (data: string | null) => {
    if (data) {
      setResult(data);
    }
  };

  const handleResult: QrReaderProps["onResult"] = (result: any) => {
    if (result) {
      setResult(result?.text);
    }
  };

  const handleOrientationChange = () => {
    setFacingMode("environment");
  };

  useEffect(() => {
    setResult(null);
    setImageData(null);
    // Add orientation change event listener
    window.addEventListener("orientationchange", handleOrientationChange);

    return () => {
      const userMedia = navigator.mediaDevices.getUserMedia({
        video: { facingMode: "environment" },
      });
      // Remove event listener on component unmount
      window.removeEventListener("orientationchange", handleOrientationChange);
      userMedia.then((stream) => {
        const tracks = stream.getTracks();
        tracks.forEach((track) => track.stop());
      });
    };
  }, []);

  useEffect(() => {
    // Access the getUserMedia function directly
    const userMedia = navigator.mediaDevices.getUserMedia({
      video: { facingMode: "environment" },
    });

    userMedia
      .then(() => {
        setLoading(false); // Camera is ready
      })
      .catch((error) => {
        setResult(null);
      });
  }, [facingMode]);

  useEffect(() => {
    if (!!result) {
      let splitedResult = result?.split("$###$");
      let finac_asset_id = splitedResult?.length && splitedResult[0];
      getSingleData(finac_asset_id);
      setResult(null);
    }
  }, [result]);

  //trying

  const decodeQRCode = (imageData: any) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      const ctx: any = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, img.width, img.height);

      const imageData: any = ctx.getImageData(0, 0, img.width, img.height);
      const code = jsQR(imageData.data, imageData.width, imageData.height);

      if (code) {
        handleScan(code.data);
      } else {
        handleError("No QR code found in the image.");
      }
    };

    img.src = imageData;
  };

  useEffect(() => {
    if (imageData) {
      decodeQRCode(imageData);
    }
  }, [imageData]);

  const handleFileSelected = (data: any) => {
    setImageData(data);
  };

  const handleError = (err: any) => {
    setResult(null);
  };

  const previewStyle: any = {
    height: 340,
    width: 320,
    marginLeft: "-3%",
  };

  const handleCameraReady = () => {
    setLoading(false);
  };

  const qrReaderProps: any = {
    delay: 300,
    onError: handleError,
    onScan: handleScan,
    onResult: handleResult,
    style: { ...previewStyle },
    facingMode: "environment",
    onLoad: handleCameraReady,
  };

  //trying
  const ImageUploader = (onFileSelected: any) => {
    const handleFileChange = (e: any) => {
      const file = e.target.files[0];
      if (file) {
        setFileName(file.name);
        const reader = new FileReader();
        reader.onloadend = () => {
          onFileSelected(reader.result);
        };
        reader.readAsDataURL(file);
      }
    };

    return <input type="file" accept="image/*" onChange={handleFileChange} />;
  };

  return (
    <div style={{ width: "80vw", marginLeft: "10%" }}>
      {singleFixedAsset?.id ? (
        // <AssetDetails
        // handleReset={handleReset}
        // singleFixedAsset={singleFixedAsset}
        // handleSubmit={handleSubmit}
        // message={message}
        // onClose={onClose}
        // />
        ""
      ) : (
        <>
          <div className="close-btn" onClick={() => onClose()}>
            <img src={CloseIcon} alt="" />
          </div>

          {ImageUploader(handleFileSelected)}

          <div className="flex-center bold mt-3">OR</div>

          {loading ? (
            <TableLoader Rows={5} ColumnPerRow={2} />
          ) : (
            <QrReader
              delay={300}
              onError={handleError}
              onScan={handleScan}
              onResult={handleResult}
              style={{ height: 340, width: 320, marginLeft: "-3%" }}
              facingMode={"environment"}
              onLoad={handleCameraReady}
              {...qrReaderProps}
            />
          )}

          <div className="bold align-qr">
            Align Qr Code Within Frame to Scan
          </div>
        </>
      )}
    </div>
  );
};

export default QrCodeScanner;
